import { REACT_APP_API_PREFIX } from "config/env";
import { DELETE, GET, POST, PUT } from "constants/methods";

const service = "cpfm";
const masterTags = `${REACT_APP_API_PREFIX}/${service}/masterTags`;

export function getMasterTags(filters) {
  const url = `${masterTags}${
    filters ? `?filters=${JSON.stringify(filters)}` : ""
  }`;
  return {
    method: GET,
    url,
  };
}

export function getMasterTagById(id) {
  const url = `${masterTags}/${id}/full`;
  return {
    method: GET,
    url,
  };
}

export function getProgramsByMasterTag(id) {
  const url = `${masterTags}/${id}/programs`;
  return {
    method: GET,
    url,
  };
}

export function updateMasterTag(id, body) {
  const url = `${masterTags}/${id}`;
  return {
    method: PUT,
    url,
    body,
  };
}

export function deleteMasterTag(id) {
  const url = `${masterTags}/${id}`;
  return {
    method: DELETE,
    url,
  };
}

export function createMasterTag(body) {
  const url = `${masterTags}`;
  return {
    method: POST,
    url,
    body,
  };
}
